import projection from '../generated/pwc505f1.json';
import { AcceptanceManifest } from '../types';

export const pwc505f1AcceptanceManifest = projection as AcceptanceManifest;
